export const ADSENSE_CLIENT = 'ca-pub-2021785550865334';

export const ADS_TXT = 'google.com, pub-2021785550865334, DIRECT, f08c47fec0942fa0\n';
